import React from "react";
import styled from "styled-components";
import {subduedTextColour} from "../../../../style/styleConsts";
import {useSelector} from "react-redux";
import {Clock} from "js-joda";
import {ActivityTopRow} from "./ActivityTopRow";
import {asLocalDate} from "../../../../util/timeDescription";
import {getEarningsTime} from "../../earnings/earnings";

const Container = styled.div`
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 10px;
    padding-right: 10px;
`;

const Ticker = styled.div`
    margin-top: 3px;
    font-weight: bold;
    font-size: 14px;
`;

const Message = styled.span`
    margin-top: 3px;
    color: ${subduedTextColour};
`;

export const EarningsAlert = ({action}) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());

    return <Container className="t-earnings-alert">
        <ActivityTopRow name="Earnings Alert" dateTime={action.dateTime}/>
        <Ticker className="t-ticker">{action.bloomberg}</Ticker>
        <Message className="t-message">
            {action.companyName} announces results on {asLocalDate(action.nextEarnings.date, clock)}
            {getEarningsTime(action.nextEarnings)}
        </Message>
    </Container>
};